import { Image } from '@lcsc-design/ui';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import Utils from '@lcsc-ui/utils/Utils';
import { Card, Button } from 'antd';
import Cookies from 'js-cookie';

import CardStyle from './myStyle';

const myImg1 = '//static.szlcsc.com/ecp/assets/newWeb/smt/product1.png';
const myImg2 = '//static.szlcsc.com/ecp/assets/newWeb/smt/product2.png';
const myImg3 = '//static.szlcsc.com/ecp/assets/newWeb/smt/product3.png';
const myImg4 = '//static.szlcsc.com/ecp/assets/newWeb/smt/product4.png';
const myImg5 = '//static.szlcsc.com/ecp/assets/newWeb/smt/product5.png';
const myImg6 = '//static.szlcsc.com/ecp/assets/newWeb/smt/product6.png';
const imgArr = [myImg1, myImg2, myImg3, myImg4, myImg5, myImg6];

const ProductCard = ({ data }) => {
  const gotoBuried = () => {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      cp: 'PCB_SMT_Landing_page',
      op: `Instant_Pricing${data.order + 1}`,
      data: {
        HF: data.src[0],
      },
    });
  };
  const gotoBuriedAndJoin = async () => {
    gotoBuried();
    window.open(data.src[0] + `${data.src[0].includes('?') ? '&' : '?'}${groupJumpUrl()}`, '_blank');
  };
  const stopPropagation = (e) => {
    e.stopPropagation();
  };
  function groupJumpUrl() {
    const jlcGroup_source = Cookies.get('jlcGroup_source');
    const operation_code_mark = Cookies.get('cookies_save_operation_code_mark');
    let query = '';
    if (jlcGroup_source) {
      query = jlcGroup_source;
    } else if (operation_code_mark) {
      query = 'lc_' + operation_code_mark;
    } else {
      query = 'lc';
    }
    return `jlcGroup_source=${query}`;
  }
  return (
    <div vertical className="flex-warp flex p-[10px_0] align-top">
      <CardStyle>
        <Card
          className="myProductCard cursor-pointer transition-transform hover:translate-y-[-10px]"
          style={{
            width: 328,
            height: 475,
            fontSize: '14px',
          }}
        >
          <Image
            src={imgArr[data.order - 1]}
            alt="PCB/SMT面板"
            className="h-[142px] w-[300px]"
            onClick={gotoBuriedAndJoin}
          />
          <div className="p-[16px_13px]" onClick={gotoBuriedAndJoin}>
            <h2 className="mb-[6px] flex h-[28px] text-[20px] font-bold leading-[28px] tracking-[1px] text-[#222]">
              {data.label}
            </h2>
            <p className="mb-[10px] text-[#7A7979]">
              {!data.type ? data.minNum + '片/' : data?.type === '2' ? '低至' : '超低价格'}
              <b className="p-[0px_4px] text-[20px] text-[#F7650E]">
                ￥{data.minPrice}
                {data?.type === '2' ? '/m²' : ''}
              </b>
              起
              <span className="ml-[30px]">
                最快
                <b className="p-[0px_4px] text-[20px] text-[#F7650E]">{data.delTime}</b>
                发货
              </span>
            </p>
            <Card.Meta
              description={
                <>
                  <ul className=" mb-[12px] text-[#222]">
                    {data.detailArr.map((item, index) => (
                      <li key={index} className="flex items-center leading-[24px]">
                        <i className="mr-[8px] h-[7px] w-[7px] rounded-[50%] bg-[#d2d2d2]"></i>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <p className="leading-[22px] text-[#898989]">{data.describe}</p>
                </>
              }
            />
            {/* 底部按钮 */}
            <div
              className="absolute bottom-[22px] flex  w-[92%] justify-between align-middle"
              onClick={stopPropagation}
            >
              <Button type="primary" className="rounded-[15px]" onClick={gotoBuriedAndJoin}>
                计算报价
              </Button>
              {/* <a
                href={data.src[1]}
                target="_blank"
                rel="nofollow"
                className="text-[#616161] cursor-pointer"
              >
                了解更多 &#10095;
              </a> */}
            </div>
          </div>
        </Card>
      </CardStyle>
    </div>
  );
};

export default ProductCard;
